import React, { useContext, useEffect, useState } from 'react';
import { createContext } from 'react';
import axios from 'axios'
import { UserContext } from './userContext';
import {toast} from 'react-toastify'
import Spinner from '../components/loading/spinner';

export const UserDataContext = createContext()

const UserDataContextProvider =(props)=>{

        const [userData,setUserData]=useState(null)
        const [loading,setLoading]=useState(true)

        const {user,logout} = useContext(UserContext)
      
        
        function getUserData(){

if(user){
    axios.post("https://vsam.me/api/api.php?request=getUserDetails",{
        "user_id":user.userid,"token":user.token
    }
    ).then(res=>{
        if(res.data.status===false){
             logout();
             toast.error(res.data.msg)
         }
         if(res.data.status===true){
         setUserData(res.data.userData[0])
    //console.log(res.data.userData[0])
        

         }
     }).catch(err=>console.log("err"+err))

    }   
        }

        useEffect(()=>{
            getUserData()

        },[user])

//console.log(userData)

    return(
        <UserDataContext.Provider value={{userData,getUserData}}>
            {userData?
            props.children:
            
            <Spinner/>
            }
        </UserDataContext.Provider>

    )
}

export default UserDataContextProvider